import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Dashboard, DashboardConfiguration } from 'types/dashboard';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateDashboardParams = {
  name: string;
  configuration: DashboardConfiguration;
};

export function useCreateDashboard({
  onMutate,
  onSettled,
  onError,
  ...options
}: UseMutationOptions<Dashboard, APIError, UseCreateDashboardParams> = {}) {
  const { applicationID, client } = useAPI();
  const queryClient = useQueryClient();

  return useMutation(
    async (params) => {
      const { data } = await client.post(
        `/internal/apps/${applicationID}/dashboards`,
        params
      );

      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['dashboards']);
      },
    }
  );
}
